export function calcScore(mistakes, total, duration) {
   //console.log("Mistakes: ", mistakes, " total: ", total) ;
   return 100 - ((100 * mistakes) / total);
}
